// eslint-disable-next-line no-shadow
export enum DataHooks {
  Root = 'dialog',
  Title = 'dialog-title',
  Content = 'dialog-content',
  Button = 'dialog-confirmation-button',
  Link = 'dialog-confirmation-link',
}
